<template>
  <div style="width: 100%;">
    <nut-navbar @on-click-back="onBack" :title="title" :left-show="leftShow" :right-show="rightShow"
                @on-click-more="onMore"
                @on-click-title="onTitle"
                style="width: 100%;z-index: 222;"
                :style="{background:background ? background : '#fff',color:background ? '#fff' : '#2c3e50',position: top ? 'fixed' : 'relative'}"
    >
      <a slot="back-icon">
        <img :src="require('../../../../resource/img/device/icon_left.png')"
             style="height: 17px;width: auto;display: inline-block;vertical-align: middle;"/>
      </a>
      <a v-if="!more" slot="more-icon">
        <img :src="require('../../../../resource/img/icon_home_page.png')"
             style="height: 25px;width: auto;display: inline-block;vertical-align: middle;"/>
      </a>
    </nut-navbar>
    <div v-if="top" style="height:40px;z-index:-1;"></div>
  </div>
</template>

<script>
/**
 * 导航栏
 * @export
 */
export default {
  name: 'NBar',
  props: {
    //标题
    title: {
      type: String,
      default: 'NBar'
    },
    //左边按钮
    leftShow: {
      type: Boolean,
      default: true
    },
    //右边按钮
    rightShow: {
      type: Boolean,
      default: true
    },
    //导航栏背景色
    background: {
      type: String,
      default: ''
    },
    //是否固定头部
    top: {
      type: Boolean,
      default: false
    },
    //更多
    more: {
      type: Boolean,
      default: false
    },
    //标题点击事件
    onClickTitle: {
      type: Function
    },
    //左边返回事件
    onClickBack: {
      type: Function
    },
    //右边点击事件
    onClickHome: {
      type: Function
    }
  },
  methods: {
    /**
     * 标题点击事件
     */
    onTitle: function () {
      if (typeof this.onClickTitle === 'function') {
        this.onClickTitle()
      }
    },
    onBack: function () {
      if (typeof this.onClickBack === 'function') {
        this.onClickBack()
      } else
        this.$router.back()
    },
    onMore: function () {
      if (typeof this.onClickHome === 'function') {
        this.onClickHome()
      } else
        this.$router.replace('/device/DeviceHome')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/comp/NBar/NBar.vue